import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import { nameComparator } from "@mapmycustomers/shared/util/comparator";

const sortFunnelList = (funnels: Funnel[], favouriteFunnelsIds: Funnel["id"][]): Funnel[] =>
  [...funnels].sort((a, b) => {
    const isAFavorite = favouriteFunnelsIds.includes(a.id);
    const isBFavorite = favouriteFunnelsIds.includes(b.id);
    if (isAFavorite !== isBFavorite) {
      return isAFavorite ? -1 : 1;
    }
    return nameComparator(a, b);
  });

export default sortFunnelList;
